import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ok",
  "use": "ok-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ok\"><defs><style></style></defs><path d=\"M512 64a448 448 0 110 896 448 448 0 010-896zm0 64a384 384 0 100 768 384 384 0 000-768zm-57.792 492.544l259.2-259.2a32 32 0 0148.896 40.832l-3.648 4.48-281.792 281.728a32 32 0 01-40.832 3.712l-4.48-3.712L265.408 522.24a32 32 0 0140.832-48.96l4.48 3.712 143.552 143.616 259.2-259.2-259.2 259.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol